import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Tracks page views into our internal analytics collection.
 * Mounted once inside PublicLayout — fires on route change.
 */
export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    // fire and forget; don't block UX on failure
    api.post("/analytics/track", {
      event_type: "page_view",
      path: pathname,
      referrer: document.referrer || "",
    }).catch(() => {});
    // GA4 pageview
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "page_view", { page_path: pathname });
    }
  }, [pathname]);
  return null;
}
